import { render, staticRenderFns } from "./ServiceAreaTable.vue?vue&type=template&id=2c48ffc9"
import script from "./ServiceAreaTable.vue?vue&type=script&lang=js"
export * from "./ServiceAreaTable.vue?vue&type=script&lang=js"
import style0 from "./ServiceAreaTable.vue?vue&type=style&index=0&id=2c48ffc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports